<template>
  <section class="sticky top-0 z-40">
    <TopbarRibbon />
    <MainNavigation />
  </section>

  <!-- content -->
  <slot />

  <CaseClubSocial hide-title show-navigate-desktop />
  <FooterSecureCheckout />
  <FooterMarqueen />
  <FooterNavigation />
</template>

<script lang="ts" setup>
// ─── Layout: Setup layout ──────────────────────────────────────
const appConfig = useAppConfig()
const fbAppId = appConfig.fbAppId as string
const head = useLocaleHead({
  addDirAttribute: true,
  identifierAttribute: 'id',
  addSeoAttributes: true
})

useHead({
  titleTemplate: '%s',
  meta: [
    {
      property: 'fb:app_id',
      content: fbAppId
    }
  ],
  htmlAttrs: {
    lang: head.value.htmlAttrs.lang,
    dir: head.value.htmlAttrs.dir
  }
})
</script>
